import React from "react";
import { Card, CardBody, Col, Spinner } from "reactstrap";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Analytics = ({ loading, titleBoxs, totalUsers }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="py-1">
        <h5>Total Dashboard Users: {totalUsers}</h5>
      </div>
      <hr
        style={{
          width: "97.8%",
        }}
        className="text-muted d-flex m-auto mb-4 mt-0"
      />
      {titleBoxs.map((item, key) => (
        <Col xl={4} md={6} sm={12} key={key}>
          <div className={"card-animate border rounded mb-3 p-3 "}>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className={
                    " justify-content-between fw-semibold d-flex align-items-center mb-0" +
                    item.labelClass
                  }
                >
                  {item.label}
                  {":"}
                  <div className="avatar-xs ms-auto  flex-shrink-0">
                    <span
                      onClick={() => navigate(item.link)}
                      className={
                        "avatar-title cursor-pointer rounded mt-0 fs-5 bg-transparent"
                      }
                    >
                      <img src={item.icon} alt="icon" />
                    </span>
                  </div>
                </h5>
              </div>
            </div>
            <div className="d-flex align-items-end justify-content-between mt-4">
              <div>
                <h4
                  className={
                    "fs-22 fw-semibold ff-secondary  " + item.counterClass
                  }
                >
                  <span className="counter-value text-primary" data-target="559.25">
                    {loading ? (
                      <Spinner
                        size="xs"
                        color="primary"
                        style={{ width: "1rem", height: "1rem" }}
                      />
                    ) : (
                      <CountUp
                        start={0}
                        prefix={item.prefix}
                        suffix={item.suffix}
                        separator={item.separator}
                        end={item.counter}
                        decimals={item.decimals}
                        duration={4}
                      />
                    )}
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </>
  );
};

export default Analytics;
